export default __webpack_public_path__ + "static/banner-why-you-shouldnt-be-scared-of-credit-cards-e112a544538a33bea1a2f5d0898afa19.jpg";